// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@adl/App/Store/Reducers";
import { VideoDocumentModel } from "@adl/App/Store/Reducers/ProductDetailsReducer";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getProductVideos(state: CustomAppState, product: ProductModel): VideoDocumentModel[] | undefined {
    if (!product) {
        return undefined;
    }
    const customProductState = state.xProductDetails.byId[product.id];
    return customProductState ? customProductState.videos : undefined;
}

export function getSelectedVideoIndex(state: CustomAppState, product: ProductModel) {
    let selectedVideoIndex = -1;
    if (product) {
        const customProductState = state.xProductDetails.byId[product.id];
        if (customProductState) {
            selectedVideoIndex = customProductState.selectedVideoIndex;
        }
    }
    return selectedVideoIndex;
}

export function getSelectedVideo(state: CustomAppState, product: ProductModel): VideoDocumentModel | undefined {
    if (!product) {
        return undefined;
    }
    const customProductState = state.xProductDetails.byId[product.id];

    return customProductState && customProductState.selectedVideoIndex > -1
        ? customProductState.videos[customProductState.selectedVideoIndex]
        : undefined;
}

export function getProductSpecialDiscontinuedItem(state: CustomAppState, product: ProductModel): string | undefined {
    if (!product) {
        return undefined;
    }
    const customProductState = state.xProductDetails.byId[product.id];
    return customProductState ? customProductState.specialDiscontinuedItem : undefined;
}
